import { payload } from "../../../../../node_modules/@sveltejs/kit/src/runtime/client/payload.js";
const env = payload.env;

export const PUBLIC_SENTRY_DSN = "https://a7d72f8d6b7b4eb3a42b46a45107e9df@o4504770760212480.ingest.us.sentry.io/4505589265793025";
export const PUBLIC_POSTHOG_HOST = "https://chainspect.app/ingest";
export const PUBLIC_POSTHOG_KEY = "phc_tDrRMAsAbLAWURfuf8EKgRR4BpMwzINTYzFiB8kbfp0";
